var _path, _path2, _path3, _path4, _path5, _g, _path6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#blog_svg__clip0_999_984)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.696 4.54l4.267.473M3.866 8.293a9.744 9.744 0 013.14-1.163M5.923.893l1.95 2.78",
    stroke: "#0C0A0C",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.806 4.453c-.823-1.13-1.99-1.94-3.257-2.4-1.823-.656-4.036-.546-5.683.554-1.237.826-2.03 2.233-2.177 3.726-.073.744.014 1.51.264 2.214.28.783.843 1.46.913 2.316.06.75-.05 1.554-.07 2.31-.013.554.307 1.06.807 1.27l2.33.974c.53.223 1.14.063 1.506-.394.62-.773 1.097-1.81 1.954-2.35 1.81-1.14 3.756-1.63 4.34-3.956.366-1.457-.047-3.067-.924-4.267l-.003.003z",
    fill: "#FFBF3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.003 13.913c1.527-2.366.46-3.526.147-5.56-.254-1.623.666-3.32 2.516-2.85.914.234 1.74 1 1.997 1.91.137.487.083 1.254-.32 1.617-.89.793-1.553-.523-1.54-1.27.02-1.037.69-2.11 1.64-2.54 1.507-.68 3.263.563 3.163 2.207-.11 1.826-2.213 2.353-3.433 3.283-1.493 1.14-2.373 2.813-2.243 4.713",
    stroke: "#0C0A0C",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.32 14.85l-5.867-2.123c-.173-.063-.353.023-.39.183L8.5 15.44c-.03.13.046.267.183.327l1.253.563c.11.05.184.154.187.264l.04 1.043c.003.12.09.23.213.273l1.337.474c.13.046.273.006.347-.094l.56-.78c.07-.1.206-.14.336-.097l.997.317c.143.047.293-.01.353-.13l1.197-2.35c.077-.146-.01-.333-.187-.396l.004-.004z",
    fill: "#0C0A0C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "blog_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 12,
    width: 8,
    height: 7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.32 14.85l-5.867-2.123c-.173-.064-.353.023-.39.183L8.5 15.44c-.03.13.046.267.183.327l1.253.563c.11.05.184.153.187.263l.04 1.044c.003.12.09.23.213.273l1.337.473c.13.047.273.007.347-.093l.56-.78c.07-.1.206-.14.336-.097l.997.317c.143.047.293-.01.353-.13l1.197-2.35c.077-.147-.01-.333-.187-.397l.004-.003z",
    fill: "#0C0A0C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#blog_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.881 13.857a.214.214 0 01.275-.128l7.633 2.776a.214.214 0 01-.146.403l-7.634-2.777a.214.214 0 01-.128-.274z",
    fill: "#fff"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.35 22.327c2.334 0 4.226-.593 4.226-1.324 0-.73-1.892-1.323-4.226-1.323-2.335 0-4.227.593-4.227 1.323 0 .731 1.892 1.324 4.227 1.324z",
    fill: "#0C0A0C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "blog_svg__clip0_999_984"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

export default SvgBlog;